// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Overview_AlertsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/overview/alerts
 *
 * Three actionable alert categories surfaced as a flat list of typed rows.
 * Stock alerts are NOT included on this tab per design decision #5 — they
 * live on the Operação · Service Orders tab.
 *
 * Alert kinds:
 * - "compromisso_sem_recebimento"     : compromisso Realizado há > 7 dias
 *                                       sem recebimento integral.
 * - "so_item_atrasado"                : so_order_items with
 *                                       expected_delivery_at < today AND
 *                                       delivered_at IS NULL.
 * - "recebimento_pendente_vencido"    : compromisso non-Cancelado with
 *                                       data_hora_inicio < today AND no
 *                                       matching recebimentos at all.
 */
import type { Overview_AlertRow } from './Overview_AlertRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Overview_AlertsResponseDados = Overview_AlertRow[];

export type Overview_AlertsResponse = ApiResponse<Overview_AlertsResponseDados>;

registerResponseContract('Overview_AlertsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      kind:           { type: 'string',  required: false },
      count:          { type: 'number',  required: false },
      amount:         { type: 'number',  required: false },
      reference_date: { type: 'string',  required: false },
    },
  },
})
